export default "__VITE_ASSET__Ble67pS8__"